{
    "IncludeintransitioningsequenceLabel": "Incluir na sequência de exibição de transição do relatório:",
    "RptdisplintervaltimeLabel": "Tempo de intervalo de exibição do relatório:",
    "RptdisplintervaltimePlaceholder": "5s",
    "DisplaySwitching_SectionHeader": "Comutação Automática de Exibição de Relatório",
    "NAME": "DisplaySwitching"
}